import m from "../../geodata/es2015/sriLankaLow";
window.am4geodata_sriLankaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sriLankaLow.js
// module id = null
// module chunks = 